import { getRuntimeConfig } from '@retail/funnel-components';

// eslint-disable-next-line camelcase
__webpack_public_path__ = getRuntimeConfig('ASSETS_PUBLIC_PATH');
